import {
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import styled from "@emotion/styled";
import { DocumentType, DocumentTypeLabels } from "../interfaces/Patient";
import { theme } from "../config";

const StyledSelect = styled(Select)({
  backgroundColor: theme.pallete.background.white,
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: theme.pallete.text.gray,
    },
    "&:hover fieldset": {
      borderColor: theme.pallete.text.primary,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.pallete.text.primary,
    },
  },
  "& .MuiSelect-icon": {
    "&.Mui-disabled": {
      display: "none",
    },
  },
});

const StyledMenuItem = styled(MenuItem)({
  fontFamily: "Poppins",
  fontSize: "16px",
  "&:hover": {
    backgroundColor: theme.pallete.background.lightGray,
  },
  "&.Mui-selected": {
    backgroundColor: theme.pallete.background.lightGreen,
    "&:hover": {
      backgroundColor: theme.pallete.background.lightGreen,
    },
  },
});

interface InputLabelProps {
  disabled?: boolean;
}

const InputLabel = styled.label<InputLabelProps>`
    font-size: 16px;
    font-weight: 500;
    line-height: 23px;
    padding-bottom: 4px;
    color: ${(props) =>
      props.disabled ? theme.pallete.text.disabled : theme.pallete.text.black};
  `;

interface DocumentTypeSelectionProps {
  value: DocumentType;
  onChange: (documentType: DocumentType) => void;
  disabled?: boolean;
  label?: string;
  fullWidth?: boolean;
}

export function DocumentTypeSelection({
  value,
  onChange,
  disabled = false,
  label = "Tipo de documento",
  fullWidth = true,
}: DocumentTypeSelectionProps) {
  return (
    <FormControl fullWidth={fullWidth}>
      <InputLabel disabled={disabled}>{label}</InputLabel>
      <StyledSelect
        value={value}
        onChange={(e) => onChange(e.target.value as DocumentType)}
        disabled={disabled}
      >
        {Object.entries(DocumentTypeLabels).map(([key, label]) => (
          <StyledMenuItem key={key} value={key}>
            {label}
          </StyledMenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
}
